// src/store/permissionsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiGet } from 'src/utils/axios';
import { getUserDetailUrl } from 'src/utils/pathConst';

// Async thunk to fetch permissions
export const fetchPermissions = createAsyncThunk(
  'permissions/fetchPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiGet(`${getUserDetailUrl}/permissions`);
      // localStorage.setItem('allPermissions', JSON.stringify(response?.data?.detail));
      return response.data; // Adjust this based on your API structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const permissionsSlice = createSlice({
  name: 'permissions',
  initialState: {
    allPermissions: null,
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPermissions.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchPermissions.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allPermissions = action.payload.detail;
      })
      .addCase(fetchPermissions.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

